module.exports = __webpack_public_path__ + "src/assets/img/busd25.f7143fe9.png";